<template>
    <div class="card bg-transparent">
        <div class="card-header border-bottom">
            <i class="fas fa-check me-2"></i>Test
        </div>
        <div class="card-body p-3">
            <div class="row">
                <div class="col-12 col-sm-4 mb-4">
                    <BlogPostCard
                        header="Recent Blog Posts"
                        subtitle="What is the Customer Journey?"
                        :tags="[
                            'Conversion',
                            'Example',
                            'Test',
                            'asdfasdf',
                            'asdfasd',
                            'asdfasdf',
                            'asdfasdf',
                            'asdfasdf',
                            'asdfasdf',
                        ]"
                        :date="new Date('2022-11-12 10:00:01')"
                        dateFormat="DD.MMMM.YYYY HH:mm"
                        content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        <br />
                        <br />
                        Sit amet nulla facilisi morbi tempus iaculis. Dolor magna eget est lorem ipsum dolor sit. Turpis egestas pretium aenean pharetra magna ac placerat vestibulum lectus."
                        :links="[
                            {
                                id: 1,
                                link: '#',
                                image: '/assets/img/avatar/a1.png',
                            },
                            {
                                id: 2,
                                link: '#',
                                image: '/assets/img/avatar/a2.png',
                            },
                        ]"
                    />
                </div>
                <div class="col-12 col-sm-4 mb-4">
                    <!-- date="15.01.2024 11:00:01" -->
                    <BlogPostCard
                        header="Recent Blog Posts"
                        subtitle="What is the Customer Journey?"
                        :tags="['Example']"
                        tagClass="bg-warning text-light"
                        content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        <br />
                        <br />
                        Sit amet nulla facilisi morbi tempus iaculis. Dolor magna eget est lorem ipsum dolor sit. Turpis egestas pretium aenean pharetra magna ac placerat vestibulum lectus.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        <br />
                        <br />
                        Sit amet nulla facilisi morbi tempus iaculis. Dolor magna eget est lorem ipsum dolor sit. Turpis egestas pretium aenean pharetra magna ac placerat vestibulum lectus."
                    >
                        <template #header>
                            <div
                                class="card-header"
                            >
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >Custom Slot tag header
                            </div>
                        </template>
                        <template #footer>
                            <div
                                class="bg-danger1 text-light1 p-2 fs-4 text-center"
                            >
                                <!-- <i class="fas fa-exclamation-triangle me-2"></i>Salam -->
                                <div class="btn btn-primary">asdfasdfasdf</div>
                            </div>
                        </template>
                    </BlogPostCard>
                </div>
                <div class="col-12 col-sm-4 mb-4">
                    <BlogPostCard
                        header="Recent Blog Posts"
                        subtitle="What is the Customer Journey?"
                        :tags="['Transformation']"
                        tagClass="bg-danger text-light"
                        date="15.01.2024 10:00:00"
                        :dateDiff="{
                            sign: false,
                            short: false,
                            as: 'hour',
                            hours: false,
                            minutes: false,
                            seconds: false,
                        }"
                        content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        <br />
                        <br />
                        Sit amet nulla facilisi morbi tempus iaculis. Dolor magna eget est lorem ipsum dolor sit. Turpis egestas pretium aenean pharetra magna ac placerat vestibulum lectus."
                    />
                </div>
            </div>
            <div class="row">

                <div class="col-12 col-sm-3 mb-4">

                    <ListAvatarCard
                        header="Latest Customers"
                        :items="[
                            {
                                title: 'Imran Badirov',
                                subtitle: 'CTO deputy manager',
                                image: '/assets/images/favicon.png',
                            },
                            {
                                title: 'Isa Mammadov',
                                subtitle: 'Programming department manager',
                                icon: '',
                            },
                            {
                                title: 'Zaur Sadiqov',
                                subtitle: 'Expert Develper',
                                icon: '',
                            },
                            {
                                title: 'Elshad Hamidov',
                                subtitle: 'Expert Develper',
                                icon: '',
                            },
                            {
                                title: 'Sabit Haciyev',
                                subtitle: 'Expert Manager',
                                icon: '',
                            },
                            {
                                title: 'Tofiq Huseynov',
                                subtitle: 'Expert Manager',
                                icon: '',
                            },
                            {
                                title: 'Bahruz Aliyev',
                                subtitle: 'Network Manager',
                                icon: '',
                            },
                        ]"
                        :colors="[
                            '100,255,100',
                            '255,100,100',
                            '255,200,100',
                            '100,100,255',
                            '125,125,125',
                            '200,100,0',
                            '20,250,250',
                        ]"
                    />

                </div>

                <div class="col-12 col-sm-3 mb-4">

                    <ImageCard
                        image="/assets/images/svg/completion-graph.svg"
                        :items="[
                            {
                                title: 'Add your personal information',
                                subtitle: 'Go Profile Edit',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-user-edit fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your phone',
                                subtitle: 'Send Verification SMS',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-paper-plane fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your Face ID',
                                subtitle: 'Upload Pictures',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-video fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Give permissions for personal data',
                                subtitle: 'View Agreement',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-briefcase fs-5',
                                iconColor: '255,200,100',
                            },
                        ]"
                    />

                </div>

                <div class="col-12 col-sm-6 mb-4">

                    <GroupCard
                        header="Trials Leads By Role"
                        image="/assets/images/svg/completion-graph.svg"
                        :columns="['Role', 'Leads']"
                        :items="[
                            {
                                title: 'Finance',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Management',
                                images: [
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                            {
                                title: 'Human Resources',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Development',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Design',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                            {
                                title: 'R&D',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                            {
                                title: 'Reliability',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Social Media',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                        ]"
                    />

                </div>

            </div>
            <!-- <div class="row">

                <div class="col-12 col-sm-6 mb-4">

                    <TimelineCard
                        image="/assets/images/svg/completion-graph.svg"
                        :items="[
                            {
                                title: 'Add your personal information',
                                subtitle: 'Go Profile Edit',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-user-edit fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your phone',
                                subtitle: 'Send Verification SMS',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-paper-plane fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your Face ID',
                                subtitle: 'Upload Pictures',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-video fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Give permissions for personal data',
                                subtitle: 'View Agreement',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-briefcase fs-5',
                                iconColor: '255,200,100',
                            },
                        ]"
                    />

                </div>

            </div> -->

            <div class="row">

                <div class="col-12 col-sm-4 mb-4">
                    <SimpleCard
                        header="Leads By Region"
                        body="Lorem Ipsum dolor amet"
                        footer="This is footer"
                    >

                        <template #header>
                            <i class="fas fa-info-circle text-secondary me-2"></i>
                            Lorem ipsum dolor default text
                        </template>

                        <template #body>
                            <h2>Lorem Ipsum</h2>
                            <h5>"Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit..."</h5>
                            <hr class="my-2">
                            <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                            scelerisque risus ac turpis ultricies rutrum. Pellentesque eget
                            venenatis sem. Nunc facilisis justo justo, sit amet varius justo
                            hendrerit et. Nulla turpis lectus, faucibus ut pellentesque sed, mollis
                            mollis ante. Fusce molestie, lectus faucibus efficitur faucibus, quam
                            nunc tempus eros, nec porta nulla elit eget ipsum. Maecenas porttitor et
                             massa nec tincidunt. Duis auctor mauris in tellus varius pharetra.
                            Aliquam id interdum turpis, fermentum rutrum massa. In eget malesuada
                            lectus. Sed facilisis magna arcu, at pharetra tortor ultrices at.
                            Phasellus eleifend diam ligula, egestas vulputate nunc cursus ac. Etiam
                            at libero sed eros finibus suscipit. Phasellus egestas quam ut lorem
                            consectetur, eu cursus turpis dictum. In tristique bibendum convallis.
                            </p>
                        </template>
                        <template #footer>
                            Lorem ipsum dolor
                        </template>
                    </SimpleCard>
                </div>

                <div class="col-12 col-sm-3 mb-4">

                    <ImageCard
                        image="/assets/images/svg/completion-graph.svg"
                        :items="[
                            {
                                title: 'Add your personal information',
                                subtitle: 'Go Profile Edit',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-user-edit fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your phone',
                                subtitle: 'Send Verification SMS',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-paper-plane fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your Face ID',
                                subtitle: 'Upload Pictures',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-video fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Give permissions for personal data',
                                subtitle: 'View Agreement',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-briefcase fs-5',
                                iconColor: '255,200,100',
                            },
                        ]"
                    />

                </div>

                <div class="col-12 col-sm-5 mb-4">

                    <ListAvatarCard
                        header="Latest Customers"
                        :items="[
                            {
                                title: 'Imran Badirov',
                                subtitle: 'CTO deputy manager',
                                image: '/assets/images/favicon.png',
                            },
                            {
                                title: 'Isa Mammadov',
                                subtitle: 'Programming department manager',
                                icon: '',
                            },
                            {
                                title: 'Zaur Sadiqov',
                                subtitle: 'Expert Develper',
                                icon: '',
                            },
                            {
                                title: 'Elshad Hamidov',
                                subtitle: 'Expert Develper',
                                icon: '',
                            },
                            {
                                title: 'Sabit Haciyev',
                                subtitle: 'Expert Manager',
                                icon: '',
                            },
                            {
                                title: 'Tofiq Huseynov',
                                subtitle: 'Expert Manager',
                                icon: '',
                            },
                            {
                                title: 'Bahruz Aliyev',
                                subtitle: 'Network Manager',
                                icon: '',
                            },
                        ]"
                        :colors="[
                            '100,255,100',
                            '255,100,100',
                            '255,200,100',
                            '100,100,255',
                            '125,125,125',
                            '200,100,0',
                            '20,250,250',
                        ]"
                    />

                </div>

            </div>
        </div>
    </div>
</template>


<script>
    import BlogPostCard from "@/components/card/BlogPostCard";
    import ListAvatarCard from "@/components/card/ListAvatarCard";
    import ImageCard from "@/components/card/ImageCard";
    import GroupCard from "@/components/card/GroupCard";
    // import TimelineCard from "@/components/card/TimelineCard";
    import SimpleCard from "@/components/card/SimpleCard";

    export default {
        name: "Dashboard2P",
        title: "Dashboard 2",
        components: {
            BlogPostCard,
            ListAvatarCard,
            ImageCard,
            GroupCard,
            // TimelineCard,
            SimpleCard,
        },
        setup() {
            return {};
        },
    };
</script>


<style lang="scss" scoped>
</style>